import * as ActionTypes from '~/actions/ActionTypes'

export const clearActiveProjectError = () => async dispatch => {
  await dispatch({ type: ActionTypes.PROJECTS_CLEAR_ERROR })
}
